import { z } from 'zod'
import { phoneNumberSchema } from 'utils/custom-schemas'

export const mainContactSchema = z.object({
  individual: z.object({
    firstName: z.string().min(1),
    lastName: z.string().min(1),
    email: z.string().min(1).email('invalidEmail'),
    phoneNumber: phoneNumberSchema({ message: 'invalidPhoneNumber' })
  }),
  relation: z.object({
    title: z.string().min(1)
  })
})

export type MainContact = z.infer<typeof mainContactSchema>
